import { render, staticRenderFns } from "./TaxCreateForm.vue?vue&type=template&id=58669881"
import script from "./TaxCreateForm.vue?vue&type=script&lang=js"
export * from "./TaxCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports